import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './footer-main.scss.js';

class FooterMain extends s {
    render() {
        return $ `<footer class="footer" role="contentinfo"><div class="footer__container"><slot></slot></div></footer>`;
    }
}
FooterMain.styles = css_248z;
customElements.define('footer-main', FooterMain);

export { FooterMain };
